import { render, staticRenderFns } from "./add_menu.vue?vue&type=template&id=22b76199&scoped=true&"
import script from "./add_menu.vue?vue&type=script&lang=js&"
export * from "./add_menu.vue?vue&type=script&lang=js&"
import style0 from "./add_menu.vue?vue&type=style&index=0&id=22b76199&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b76199",
  null
  
)

export default component.exports